import { empty as observableEmpty, from as observableFrom } from "rxjs";
import { bufferCount, catchError, distinctUntilChanged, first, map, mergeMap, skip, switchMap, timeout, withLatestFrom, } from "rxjs/operators";
import { GraphMode } from "../graph/GraphMode";
// TODO: Move
import { SubscriptionHolder } from "../utils/SubscriptionHolder";
export class CacheService {
    constructor(graphService, stateService) {
        this._graphService = graphService;
        this._stateService = stateService;
        this._subscriptions = new SubscriptionHolder();
        this._started = false;
    }
    get started() {
        return this._started;
    }
    start() {
        if (this._started) {
            return;
        }
        const subs = this._subscriptions;
        subs.push(this._stateService.currentState$
            .pipe(distinctUntilChanged(undefined, (frame) => {
            return frame.state.currentNode.key;
        }), map((frame) => {
            const trajectory = frame.state.trajectory;
            const trajectoryKeys = trajectory.map((n) => {
                return n.key;
            });
            const sequenceKey = trajectory[trajectory.length - 1].sequenceKey;
            return [trajectoryKeys, sequenceKey];
        }), bufferCount(1, 5), withLatestFrom(this._graphService.graphMode$), switchMap(([keepBuffer, graphMode]) => {
            const keepKeys = keepBuffer[0][0];
            const keepSequenceKey = graphMode === GraphMode.Sequence ? keepBuffer[0][1] : undefined;
            return this._graphService.uncache$(keepKeys, keepSequenceKey);
        }))
            .subscribe(() => {
            /*noop*/
        }));
        subs.push(this._graphService.graphMode$
            .pipe(skip(1), withLatestFrom(this._stateService.currentState$), switchMap(([mode, frame]) => {
            return mode === GraphMode.Sequence
                ? this._keyToEdges(frame.state.currentNode.key, (node) => {
                    return node.sequenceEdges$;
                })
                : observableFrom(frame.state.trajectory
                    .map((node) => {
                    return node.key;
                })
                    .slice(frame.state.currentIndex)).pipe(mergeMap((key) => {
                    return this._keyToEdges(key, (node) => {
                        return node.spatialEdges$;
                    });
                }, 6));
        }))
            .subscribe(() => {
            /*noop*/
        }));
        subs.push(this._graphService.dataAdded$
            .pipe(withLatestFrom(this._stateService.currentKey$), switchMap(([_, imageKey]) => {
            return this._graphService.cacheNode$(imageKey);
        }))
            .subscribe(() => {
            /*noop*/
        }));
        this._started = true;
    }
    stop() {
        if (!this._started) {
            return;
        }
        this._subscriptions.unsubscribe();
        this._started = false;
    }
    _keyToEdges(key, nodeToEdgeMap) {
        return this._graphService.cacheNode$(key).pipe(switchMap(nodeToEdgeMap), first((status) => {
            return status.cached;
        }), timeout(15000), catchError((error) => {
            console.error(`Failed to cache edges (${key}).`, error);
            return observableEmpty();
        }));
    }
}
//# sourceMappingURL=CacheService.js.map